import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormControlReadonlyValue]',
  standalone: true,
})
export class FormControlReadonlyValueDirective {}
